import { QueryFactory } from '@lmt/shared-types';
import { useModal } from '@lmt/unicorn-shared/app/components/common/ui-kit/modal/useModal';
import { APP_VERSION } from '@lmt/unicorn-shared/app/constants/constants';
import { logOut } from '@lmt/unicorn-shared/app/features/auth/operations';
import { isElectron } from '@lmt/unicorn-shared/app/helpers/common';
import { checkAppVersionCompatibility } from '@lmt/unicorn-shared/app/helpers/version-helper';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

/*
Pings backend every minute to refresh the token.
 */
export const PingBackendComponent = () => {
  const {
    error: queryError,
    data: version,
    isFetching,
  } = QueryFactory.VersionQuery.useVersionAuthenticatedQuery({
    refetchInterval: 60 * 1000,
    refetchIntervalInBackground: true,
    throwOnError: false,
    refetchOnMount: 'always',
  });

  const modals = useModal();
  const i18next = useTranslation();
  const isMessageShown = useRef(false);

  useEffect(() => {
    if (isMessageShown.current) return;
    if (isFetching) return;
    if (queryError) {
      console.error('versionAuthenticated errored', queryError);
    }

    if (!isElectron() || APP_VERSION === '0.0.0.DEV') {
      return;
    }

    if (version && !checkAppVersionCompatibility(APP_VERSION, version)) {
      isMessageShown.current = true;
      modals
        .showError({
          text: i18next.t('login_form.app_version_incompatible_full_message', {
            appVersion: APP_VERSION,
            apiVersion: version,
          }),
        })
        .then(() => {
          logOut();
        });
    }
  }, [queryError, version, isFetching]);

  return null;
};
